export default __webpack_public_path__ + "static/aussi-22270bb8c47a8f565e81a43ad9a9494e.jpg";